<template>
  <!-- 业务员注册-的人安康 -->
  <div class="salesmanReg">
    <!-- 页头 -->
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="closeForm"
      :crumbsList="['业务员管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="200px"
        :rules="addFormRule"
        ref="addForm"
      >
        <el-form-item
          label="手机号："
          prop="CellPhone"
          style="margin-top: 50px"
        >
          <el-input
            v-model="addForm.CellPhone"
            clearable
            style="width: 300px"
            placeholder="请输入您常用的手机号"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="登录密码："
          prop="LoginPassword"
          style="margin-top: 50px"
        >
          <el-input
            v-model="addForm.LoginPassword"
            clearable
            style="width: 300px"
            placeholder="请输入您的登录密码"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="确认密码："
          prop="ConfirmPassword"
          style="margin-top: 50px"
        >
          <el-input
            v-model="addForm.ConfirmPassword"
            clearable
            style="width: 300px"
            placeholder="请再次输入密码"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="Name" style="margin-top: 50px">
          <el-input
            v-model="addForm.Name"
            clearable
            style="width: 300px"
            placeholder="请输入您的真实姓名"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="区域：" prop="areaValue" style="margin-top: 50px">
          <el-cascader
            style="width: 300px"
            v-model="addForm.areaValue"
            :options="$store.state.citys"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="类型：" prop="Department" style="margin-top: 50px">
          <el-select v-model="addForm.Department" style="width: 300px">
            <el-option value="业务员" label="业务员"></el-option>
            <el-option value="开票员" label="开票员"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label=""
          prop=""
          style="margin-left: 200px; margin-top: 30px"
        >
          <el-button
            type="primary"
            @click="submitForm"
            round
            style="width: 140px; font-size: 20px"
            >提交
          </el-button>
        </el-form-item>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
import { mustFill } from "@/mixins/data/valid.js";
export default {
  name: "salesmanReg",
  data() {
    return {
      /**新增表单 */
      addForm: {
        CellPhone: "", // 手机号
        LoginPassword: "", // 登录密码
        ConfirmPassword: "", // 确认密码
        Name: "", // 真实姓名
        areaValue: "", //区域编码
        Department: "业务员", //开票员/业务员
      },

      /**新增表单规则 */
      addFormRule: {
        CellPhone: [mustFill], // 分类ID
        LoginPassword: [mustFill],
        ConfirmPassword: [mustFill],
        Name: [mustFill],
        areaValue: [mustFill],
        Department: [mustFill], //部门/类型
      },
    };
  },
  mounted() {},
  methods: {
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            UserName: this.addForm.CellPhone,
            PassWord: this.addForm.LoginPassword,
            Name: this.addForm.Name,
            TelPhone: this.addForm.CellPhone,
            areaValue: this.addForm.areaValue,
            Department: this.addForm.Department,

            // factory: this.addForm.Manufactor,
            // code: this.addForm.VerificationCode,
            // entId: this.addForm.Organization
          };
          this.$request({
            url: "/Management/SalesManAdmin/AddSalesMan",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.closeForm();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**刷新表格数据 */
    closeForm() {
      this.$refs["addForm"].resetFields();
    },
  },
};
</script>

<style scoped>
.salesmanReg {
  width: 100%;
  height: 100%;
}

/* 去掉滚动条 */
/* .el-scrollbar__wrap {
	overflow-y: hidden
} */

/* 表单字体大小 */
.el-form-item__label {
  font-size: 15px;
}

/* input大小 */
.el-input__inner {
  height: 30px;
}

.el-form-item__error {
  margin-left: 200px;
}

.el-form-item__content {
  margin-left: 0 !important;
}
</style>
